import { render, staticRenderFns } from "./EnquadramentoSelect.vue?vue&type=template&id=05b6967d&"
import script from "./EnquadramentoSelect.vue?vue&type=script&lang=js&"
export * from "./EnquadramentoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports